// API設定
const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || (isLocalhost ? 'http://localhost:8000' : '/api');

// 状態ラベル
export const STATE_LABELS = {
  running: '稼働',
  cleaning: '洗浄',
  idle: '停止/待機'
};

// 状態カラー
export const STATE_COLORS = {
  running: '#48bb78',
  cleaning: '#4299e1',
  idle: '#ed8936'
};

// KPIラベル
export const KPI_LABELS = {
  good: 'GOOD',
  info: 'INFO',
  bad: 'ALERT',
  warn: 'WARNING'
};
